var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAskDoctorCategory = function SvgAskDoctorCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ask-doctor-category_svg__a)",
    d: "M20.29 15.45c-5.88 0-10.65 4.768-10.65 10.65a10.6 10.6 0 0 0 2.783 7.178c-.48 1.331-1.455 2.077-2.182 2.465-.305.164-.254.591.072.71.822.298 3.588.69 5.052-.909a10.6 10.6 0 0 0 4.924 1.207c5.882 0 10.65-4.768 10.65-10.65 0-5.881-4.768-10.65-10.65-10.65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ask-doctor-category_svg__b)",
    d: "M37.878 27.681c-.588-.315-1.378-.918-1.767-1.997a8.624 8.624 0 1 0-2.383 1.834c1.185 1.296 3.55.979 4.09.738.257-.114.306-.442.059-.575z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.362 18.497V16.22c0-.174.141-.313.314-.313H30.8c.174 0 .314.14.314.313v2.276h2.275c.174 0 .314.14.314.313v2.126a.313.313 0 0 1-.314.313h-2.275v2.276a.313.313 0 0 1-.314.313h-2.125a.313.313 0 0 1-.314-.314V21.25h-2.275a.313.313 0 0 1-.314-.313V18.81c0-.174.141-.313.314-.313z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask-doctor-category_svg__a",
    x1: 10.835,
    x2: 35.008,
    y1: 14.805,
    y2: 27.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ask-doctor-category_svg__b",
    x1: 25.224,
    x2: 43.088,
    y1: -22.468,
    y2: -20.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D98EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AE5"
  })))));
};
export default SvgAskDoctorCategory;